/* eslint-disable @typescript-eslint/ban-types */
import { Button, Form } from 'antd';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CONSTANTS } from 'utilities/constants/SIMULATE';
import InputAllowNumber from '../../CU-010-01/components/Input';

type props = {
    form: any;
    detailAssessment: any;
    onSubmit: (values: any) => void;
    createClick: () => void;
    getCollapseProps: () => any;
    btnDisable: boolean;
    setBtnDisable: (value: boolean) => void;
};

const FormSimulateSale = ({
    getCollapseProps,
    form,
    detailAssessment,
    onSubmit,
    createClick,
    btnDisable,
    setBtnDisable,
}: props) => {
    const navigate = useNavigate();

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch(() => {
                setBtnDisable(true);
            });
    };

    const itemRules = {
        loanInterestRate: [
            {
                required: true,
                message: getMessage('In_Required', '借入利率'),
            },
        ],
        loanPeriod: [
            {
                required: true,
                message: getMessage('In_Required', '借入期間'),
            },
        ],
        loanPaybable: [
            {
                required: true,
                message: getMessage('In_Required', '借入額'),
            },
        ],
        currentHoldingPeriod: [
            {
                required: true,
                message: getMessage('In_Required', '現在の所有年数'),
            },
        ],
        personalFunds: [
            {
                required: true,
                message: getMessage('In_Required', '自己資金'),
            },
        ],
        rent: [
            {
                required: true,
                message: getMessage('In_Required', '家賃'),
            },
        ],
        managementFee: [
            {
                required: true,
                message: getMessage('In_Required', '管理費'),
            },
        ],
        expectedSalePrice: [
            {
                required: true,
                message: getMessage('In_Required', '売却予定価格'),
            },
        ],
    };

    return (
        <div className="section-wrapper">
            <div className="simulate-form">
                <Form form={form} onChange={onChangeForm} onFinish={onSubmit}>
                    <div {...getCollapseProps()}>
                        <div className="simulate-form-item">
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.LOAN_INTEREST_RATE}
                                    defaultValue={detailAssessment?.loanInterestRate}
                                    suffix={'%'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                    }}
                                    maxLength={4}
                                    name="loanInterestRate"
                                    fraction={true}
                                    rules={itemRules['loanInterestRate']}
                                    min={'0.00'}
                                    max={99.99}
                                    label="借入金利"
                                />
                            </div>
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.LOAN_PERIOD}
                                    defaultValue={detailAssessment?.loanPeriod}
                                    suffix={'年'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                    }}
                                    name="loanPeriod"
                                    maxLength={4}
                                    min={0}
                                    max={99}
                                    fraction={false}
                                    rules={itemRules['loanPeriod']}
                                    label="借入期間"
                                />
                            </div>
                        </div>
                        <div className="simulate-form-item">
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.LOAN_PAYBABLE}
                                    defaultValue={detailAssessment?.loanPaybable}
                                    // suffix={'万円'}
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                    }}
                                    name="loanPaybable"
                                    maxLength={9}
                                    min={0}
                                    max={999990000}
                                    rules={itemRules['loanPaybable']}
                                    fraction={false}
                                    label="借入額"
                                />
                            </div>
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.CURRENT_HOLDING_PERIOD}
                                    defaultValue={detailAssessment?.currentHoldingPeriod}
                                    suffix={'年'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                    }}
                                    name="currentHoldingPeriod"
                                    maxLength={4}
                                    min={0}
                                    max={99}
                                    fraction={false}
                                    rules={itemRules['currentHoldingPeriod']}
                                    label="現在の所有年数"
                                />
                            </div>
                        </div>
                        <div className="simulate-form-item">
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.PERSONAL_FUNDS}
                                    defaultValue={detailAssessment?.personalFunds}
                                    // suffix={'万円'}
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                    }}
                                    name="personalFunds"
                                    maxLength={9}
                                    fraction={false}
                                    min={0}
                                    max={999990000}
                                    rules={itemRules['personalFunds']}
                                    label="自己資金"
                                />
                            </div>
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.RENT}
                                    defaultValue={detailAssessment?.rent}
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                    }}
                                    name="rent"
                                    maxLength={7}
                                    min={1}
                                    fraction={false}
                                    rules={itemRules['rent']}
                                    label="家賃・共益費・管理費など（収入）"
                                />
                            </div>
                        </div>
                        <div className="simulate-form-item">
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.MANAGEMENT_FEE}
                                    defaultValue={detailAssessment?.managementFee}
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                    }}
                                    name="managementFee"
                                    maxLength={7}
                                    min={1}
                                    fraction={false}
                                    rules={itemRules['managementFee']}
                                    label="管理費・修繕積立金・その他費用など（支出）"
                                />
                            </div>
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.EXPECTED_SALE_PRICE}
                                    defaultValue={detailAssessment?.expectedSalePrice}
                                    // suffix={'万円'}
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                    }}
                                    name="expectedSalePrice"
                                    maxLength={10}
                                    min={0}
                                    fraction={false}
                                    rules={itemRules['expectedSalePrice']}
                                    label="売却予定価格"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="simulate-form-item" style={{ marginTop: 30 }}>
                        <div
                            className="simulate-form-option"
                            style={{
                                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                                background: `${btnDisable ? '#D0D3D8' : '#fff'}`,
                            }}
                            onClick={() => (!btnDisable ? form.submit() : null)}
                        >
                            再実行
                        </div>
                        <Button
                            type="primary"
                            disabled={btnDisable}
                            className="simulate-form-option"
                            style={{
                                background: '#4BCAE5',
                                color: '#fff',
                                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                            }}
                            onClick={() => createClick()}
                        >
                            実行結果を保存
                        </Button>
                    </div>
                    <div
                        className="simulate-form-item"
                        onClick={() =>
                            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_028_01}`)
                        }
                    >
                        <div className="simulate-form-button" style={{ background: '#1F8DDD' }}>
                            くわしく査定
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default FormSimulateSale;
